import {Component, Input, Output, OnInit, EventEmitter, ChangeDetectorRef, forwardRef, ViewChild, ElementRef, HostListener} from "@angular/core";
import {Pipe, PipeTransform} from "@angular/core";
import {debounceTime, distinctUntilChanged, throttleTime} from "rxjs/operators"
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Settings} from "./multiselect.config";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {Item} from "./item";
import {SharedDataService} from "../../services/shared/shared-data.service";
import {HelperService} from "../../services/helperService";

@Pipe({
    name: "tigMultiselectFilter"
})
export class FilterPipe implements PipeTransform {

    transform(items: any, filter: any, type: any, backendSearch: boolean = false): any {

    	if (backendSearch) {
			return items;
		}
        else if (filter && Array.isArray(items)) {
            let filterKeys = Object.keys(filter);
            // console.log('filterKeys',filterKeys,'filter',filter,'type',type,'items',items);
            return items.filter(item =>
                filterKeys.reduce((memo, keyName) => {
					// console.log('memo',memo,'keyName',keyName);
					return (memo || new RegExp(filter[keyName], "gi").test(item[keyName])) ||
						// item.options.find(obj => new RegExp(filter[keyName], "gi").test(obj[keyName])) ||
						// (memo && new RegExp(filter[keyName], "gi").test(item.parent[keyName])) ||
						(filter[keyName] === "");
				}, false
                ));
        } else {
            return items;
        }
    }
}

// @Pipe({
//     name: 'tigMultiselectHighlight'
// })
// export class HighlightSearch implements PipeTransform {
//
//     transform(value: any, args: any): any {
//         if (!args) {return value;}
//         // 'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
//         let re = new RegExp(args, 'gi');
//         return value.replace(re, "<mark>" + args + "</mark>");
//     }
// }

@Component({
    selector: "tig-multiselect",
    templateUrl: "./multiselect.component.html",
    styleUrls: ["./multiselect.component.css"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiselectComponent),
            multi: true
        }
    ],
})

export class MultiselectComponent implements OnInit, ControlValueAccessor {

    private filterText: string = "";
    private filterInput: FormControl = new FormControl();
    private _optionsOpened: boolean = false;
	/**
	 * Optionen, die der Nutzer aktuell hat - kann weniger sein, als tatsaechlich per value zugewiesen ist,
	 * siehe Rollenkonzept - wenn jmd. mit Rolle Portaladmin für EIN portal andere Nutzer mit Rechten für Mehr portale bearbeitet, sieht
	 * er/sie dennoch nur die eine Rolle
	 */
	private _items: Array<Item> = [];
    private _selected: Array<Item> = [];
    private _disabled: boolean = false;
    private _settings: Settings;
    private values: Array<any> = [];
    public count: number = 0;
    public noResults: boolean = false;
    public showSpinner: boolean = false;

    private onChangeCallback: (_: any) => void;
    private onTouchedCallback: (_: any) => void;

    @Input()
    public set selected(value: Array<any>) {
        if (!value || value.length === 0) {
            this._selected = [];
        } else {
            this._selected = value.map((item) => {
                return new Item(item);
            });
        }
    }

    @Input()
    public set disabled(value: boolean) {
        this._disabled = value;
        if (this._disabled === true) {
            this.hideOptions();
        }
    }

    @Input()
    public set settings(settings: Settings) {
        settings.enableFilter = settings.enableFilter != null?settings.enableFilter:true;
        settings.placeholder = settings.placeholder != null?settings.placeholder:"Please select";
        settings.filterPlaceholder = settings.filterPlaceholder != null?settings.filterPlaceholder:"Filter";
        settings.multiple = settings.multiple != null?settings.multiple:false;
        this._settings = settings;
    }


    /**
     * @desc An array with all items for MultiselectComponent: [items]=...
     * @param items
     */
    @Input()
    public set items(items: Array<any>) {
        // search through the search fields in backend
        let search = (this._settings.options.href.length > 0 && this._settings.options.searchFields),
            newItem;
        if (items && items.length > 0) {
            this._items = items.map((item) => {
                if (search) {
                    newItem = {
                        id:  item[this._settings.options.label.id],
                        text: item[this._settings.options.label.text],
                        options: []
                    };
                    item.options.forEach(option => {
                        newItem.options.push({id: option[this._settings.options.option.id], text: option[this._settings.options.option.text]});
                    });
                }
                else
                {
                    newItem = {
                        id:  item[this._settings.id],
                        text: item[this._settings.text],
                        options: []
                    };
                    item.options.forEach(option => {
                        newItem.options.push({id: option[this._settings.id], text: option[this._settings.text]});
                    });
                }
                return new Item(newItem);
            });
            this.HelperService.log({class: 'MultiselectComponent', function: 'set items'}, {items: items, _items: this._items});
        }
    }

    @Output() public selectedEvent:EventEmitter<any> = new EventEmitter();


    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
        private SharedDataService: SharedDataService,
        private HelperService: HelperService
    ) {
        this.clickedOutside = this.clickedOutside.bind(this);
    }

    ngOnInit() {
        this.filterInput
            .valueChanges
            .pipe(
            debounceTime(500),
            distinctUntilChanged(),)
            .subscribe(term => {
            this.filterText = term;
            // this.changeDetectorRef.markForCheck();
            if (this._settings.options.href.length > 0 && this._settings.options.searchFields)
            {
                this.showSpinner = true;
                this.SharedDataService.getContents(this._settings.options.href, true, term, this._settings.options.searchFields.search)
                    .subscribe(
                        response => {
                            this.processSearchResults(response, false);
                        },
                        error => {
                            this.HelperService.error({class: 'MultiselectComponent', function: 'ngOnInit'}, error);
                            this.showSpinner = false;
                        },
                        () => {
                        }
                    );
            }
        });
    }

    private processSearchResults(response, checked: boolean): void {
        // leave checked items in array
        this._items = this._items.filter(obj =>  (typeof obj.options != 'undefined' && obj.options[0].checked));
        // get the path to the array with options
        let path: Array<string> = this._settings.options.array.split('.'),
            items: any = response.body[path.shift()];
        for (let x of path) {
            items = items[x];
        }
        // no search results
        this.noResults = (items.length == 0);
        items.forEach((item) => {
            if (!this._items.find(obj =>  obj.id == item.id)) {
                // get attribute titles for option text
                let path: Array<string> = this._settings.options.option.text.split('+'),
                    optionText = item[path.shift()];
                for (let x of path) {
                    optionText += ', ' + item[x];
                }
                let object = {
                    id: item[this._settings.options.label.id],
                    text: item[this._settings.options.label.text],
                    options: [{
                        id: item[this._settings.options.option.id],
                        text: optionText + ' | '+item[this._settings.options.option.id],
                        checked: checked,
                        // only enable fields when multiselect is allowed or no option is selected
                        disabled: (this._settings.multiple ? false : this.count > 0)
                    }]
                };
                // option selected
                if (checked) {
                    this.count++;
                } // end if

                this._items.push(new Item(object));
            }
        });
        this.showSpinner = false;
        // this.changeDetectorRef.detectChanges()
        this.HelperService.log({class: 'MultiselectComponent', function: 'processSearchResults'}, {items: this._items});
    }

    public getItems(): Array<any> {
        return this._items;
    }

    public getSelected(): Array<any> {
        return this._selected;
    }

    public getDisabled(): boolean {
        return this._disabled;
    }

    private hideOptions():void {
        this._optionsOpened = false;
    }

    public clickedOutside(): void {
        this.hideOptions();
    }

    public getSettings(): Settings {
        return this._settings;
    }

    public optionsOpened(): boolean {
        return this._optionsOpened;
    }

    public sanitize(html:string):SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    public doEvent(type:string, value:any): void {
        // set event
        if ((this as any)[type] && value) {
            (this as any)[type].next(value);
        }
    }

    public select(option: any) {

        option.checked = !option.checked;
        this.count = (option.checked)?this.count+1:this.count-1;
        let selected = [];

        // search through the search fields in backend
        if (this._settings.options.href.length > 0 && this._settings.options.searchFields)
        {
            let options = [];
            this._items.forEach((_item) => {
                _item.options.forEach((_option) => {
                    // if multiple selection is disabled disable all other options
                    if (!this._settings.multiple && option.id != _option.id) {
                        _option.disabled = !_option.disabled;
                    }
                    if(_option.checked && (this._settings.multiple || options.length === 0))
                    {
                        options.push(_option.id);
                    } // end if
                });

                if (options.length > 0) {
					this.values = options;
                }
                else
				{
					// wenn nicht gewaehtl ist setze Werte zurueck
					this.values = [];
				} // end if
            });
        }
        else
        {
			let INT_index_client = this.values.findIndex((OBJ_item) => OBJ_item.id ==  option.parent.id);

			// Mandant schon vorhanden - aendere seine Optionen
			if(INT_index_client !== -1)
			{
				let OBJ_client = this.values[INT_index_client];
				// fuege option hinzu
				if(option.checked)
				{
					OBJ_client.roles.push({[this._settings.id]: option.id,  [this._settings.text]: option.text})
				}
				else
				{
					// falls vorhanden loesche option raus
					let INT_index_role = OBJ_client.roles.findIndex((OBJ_item) => OBJ_item.id == option.id);
					if(INT_index_role !== -1)
					{
						if(OBJ_client.roles.length > 1)
						{
							// mehr als eine Rolle vorhanden, trenne nur aktuelle heruas
							OBJ_client.roles.splice(INT_index_role, 1);
						}
						else
						{
							// only option left is deleted - delete whole parent value
							this.values.splice(INT_index_client, 1);
						} // end if

					} // end if

				} // end if
			}
			else
			{
				// push new parent to array
				this.values.push({[this._settings.id]: option.parent.id, [this._settings.text]: option.parent.text, [this._settings.options.name]: [{[this._settings.id]: option.id,  [this._settings.text]: option.text}]});
			} // end if

        } // end if

        // set value (ControlValueAccessor)
        this.onChangeCallback(this.values);
        this.doEvent("selectedEvent", this.values);

        // if not multiple select, then hide options
        if (option.checked && this._settings.multiple === false) {
            this.clickedOutside();
        } // end if

    } // end function select

    toggleOptions(event) {
        if (!this._disabled) {
            let classList = event.target.classList;
            if (classList.contains("selected") || classList.contains("placeholder") /*|| classList.contains("option")*/) {
                this._optionsOpened = !this._optionsOpened;
            }
            // console.log("this._optionsOpened",this._optionsOpened);
            // option dropdown was closed
            if (!this._optionsOpened) {
                this.onTouchedCallback(event.target.value);
            }
        }
    }

    clearFilter() {
        this.filterText = "";
    }

    /**
     * Function > writeValue
     * @desc The writeValue method is used by formControl to set the value to the native form control.
     * @implements ControlValueAccessor
     * @param value
     */
    public writeValue(value: any): void {
        this.HelperService.log({class: 'MultiselectComponent', function: 'writeValue'}, {value: value});

        if (value && value.length > 0) {
			// Speichere Werte hier in der Komponente
			this.values = value;
            // search through the search fields in backend -> get selected options from backend
            if (this.isBackendSearch()) {
                value.forEach((item) => {
                    this.showSpinner = true;
                    this.SharedDataService.getContents(this._settings.options.href, true, item, this._settings.options.searchFields.assigned)
                        .subscribe(
                            response => {
                                this.processSearchResults(response, true);
                            },
                            error => {
                                this.HelperService.error({class: 'MultiselectComponent', function: 'writeValue'}, error);
                                this.showSpinner = false;
                            },
                            () => {}
                        );
                });
            }
            else
            {
                value.forEach((item) => {
                    let OBJ_item = this._items.find(x => x.id == item.id);
                    if (OBJ_item != null && OBJ_item.options != null && item[this._settings.options.name] != null) {
                        item[this._settings.options.name].forEach((option) => {
                            let OBJ_option = OBJ_item.options.find(x => x.id == option.id);

                            // Hat der aktuelle Nutzer diese Option auch in seiner Auswahl?
                            if(OBJ_option)
							{
								OBJ_option.checked = true;
								this.count++;
								if (!this._settings.multiple) {
									this._items.forEach((_item) => {
										_item.options.forEach((_option) => {
											if (OBJ_option.id != _option.id && OBJ_option.parent.id == _option.parent.id) {
												_option.disabled = !_option.disabled;
											}
										});
									});
								}
							} // end if

                        });
                    }

                });
            }
        }
    }

    /**
     * Function > registerOnChange
     * @desc The registerOnChange method is used by formControl to register a callback that is expected to be triggered every time the native form control is updated.
     * @implements ControlValueAccessor
     * @param fn
     */
    public registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    /**
     * Function > registerOnTouched
     * @implements ControlValueAccessor
     * @param fn
     */
    public registerOnTouched(fn: any):void {
        this.onTouchedCallback = fn;
    }


	/**
	 * Function > isBackendSearch
	 * @return {boolean}
	 */
	public isBackendSearch(): boolean {
		let settings = this.getSettings();
		return !!(settings.options.href.length > 0 && settings.options.searchFields);
	}
}
